import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { ToastrService } from 'ngx-toastr';
import { loadUser } from 'src/app/shareModule/states/user-details/user-details.action';
import { SUBSCRIPTION_PRICE_MAP } from 'src/app/shareModule/constant/subscription';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import Swal from 'sweetalert2';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-advanced-settings-super-seller',
  templateUrl: './advanced-settings-super-seller.component.html',
  styleUrls: [
    './advanced-settings-super-seller.component.scss',
    '../advanced-settings.component.scss',
  ],
})
export class AdvancedSettingsSuperSellerComponent implements OnInit {
  public userInfo: any = {
    level: 1,
  };
  public showList: boolean = false;
  validSubscription: boolean;
  currentSubscription: any = null;
  constructor(
    private store: Store<AppState>,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private customerService: CustomerService,
    @Inject('WINDOW') private window,
    private route: ActivatedRoute
  ) {
    this.store.pipe(select(selectUser)).subscribe((user: any) => {
      this.userInfo = user;
      this.validSubscription = user?.subscription != null;
      this.currentSubscription = user?.subscription;
      this.cdr.detectChanges();
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (params.status) {
        if (params.status == 'success') {
          this.local.alertSuccess({
            message: 'Subscription created successfully',
          });
        } else if (params.status == 'failed') {
          this.local.alertError({
            message: 'Subscription creation failed',
          });
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}));
  }

  handleSubscribe(
    token: string,
    subc: number = 0,
    notification_code: string = 'DEFAULT'
  ) {
    const priceMap = SUBSCRIPTION_PRICE_MAP;

    const selectedPrice = priceMap[token];
    if (!selectedPrice) {
      return;
    }

    if (selectedPrice.type != 'diamond') {
      if (this.userInfo?.level < 5) {
        this.toastr.error(
          'You have to be level 5 and above to subscribe or purchase tokens'
        );
        return;
      }
    }

    this.local.alertLoading({ message: 'Processing the Request' });

    this.customerService
      .checkoutCreate({
        userId: this.userInfo?.id,
        productId: selectedPrice.priceId,
        productType: selectedPrice.type,
        productName: selectedPrice.name,
        productPrice: selectedPrice.price,
        totalAmount: selectedPrice.price,
        paymentMethod: 'stripe',
      })
      .subscribe({
        next: (response: any) => {
          this.local.alertLoading({
            title: 'Order Created Successfully',
            message: 'Please wait while we redirect you to the payment page',
          });
          this.window.location.href = response.body.url;
        },
        error: (error) => {
          this.toastr.error(
            error.error.message || 'Subscription creation failed'
          );
          Swal.close();
        },
      });
  }

  handleManageSubscription() {

    let formData = new FormData();
    formData.append('userId', this.userInfo?.id);

    this.local.alertLoading({ message: 'Processing the Request' });
    this.customerService.checkoutManage(formData).subscribe({
      next: (response: any) => {
        this.local.alertLoading({
          title: 'Portal Session Created Successfully',
          message: 'Please wait while we redirect you to the portal',
        });
        this.window.location.href = response.body.url;
      },
      error: (error) => {
        this.local.alertError({
          message: 'Portal Session Creation Failed',
        });
        this.toastr.error(error.error.message);
      },
    });
  }
}
